// extracted by mini-css-extract-plugin
module.exports = {"container":"Cuc37m","text":"_3RiTgU"};